import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="121"
      height="86"
      fill="none"
      viewBox="0 0 121 86"
    >
      <mask
        id="mask0_2081_39"
        style={{ maskType: "luminance" }}
        width="17"
        height="16"
        x="104"
        y="0"
        maskUnits="userSpaceOnUse"
      >
        <path fill="#fff" d="M104.568.54h16.392v15.175h-16.392V.541z"></path>
      </mask>
      <path
        fill="#fff"
        d="M112.162.54h1.194a7.552 7.552 0 110 15.103h-1.194a7.55 7.55 0 110-15.102z"
      ></path>
      <mask
        id="mask1_2081_39"
        style={{ maskType: "luminance" }}
        width="17"
        height="16"
        x="104"
        y="35"
        maskUnits="userSpaceOnUse"
      >
        <path
          fill="#fff"
          d="M104.568 35.287h16.392v15.24h-16.392v-15.24z"
        ></path>
      </mask>
      <path
        fill="#fff"
        d="M112.162 35.394h1.194a7.554 7.554 0 010 15.106h-1.194a7.552 7.552 0 01-7.55-7.553c0-4.17 3.38-7.553 7.55-7.553z"
      ></path>

      <mask
        id="mask2_2081_39"
        style={{ maskType: "luminance" }}
        width="17"
        height="16"
        x="104"
        y="70"
        maskUnits="userSpaceOnUse"
      >
        <path
          fill="#fff"
          d="M104.568 70.247h16.34v15.061h-16.34v-15.06z"
        ></path>
      </mask>
      <path
        fill="#fff"
        d="M112.162 70.251h1.194a7.553 7.553 0 017.552 7.553 7.553 7.553 0 01-7.552 7.55h-1.194a7.551 7.551 0 010-15.103z"
      ></path>

      <mask
        id="mask3_2081_39"
        style={{ maskType: "luminance" }}
        width="86"
        height="16"
        x="0"
        y="70"
        maskUnits="userSpaceOnUse"
      >
        <path fill="#fff" d="M.092 70.247h85.262v15.061H.092v-15.06z"></path>
      </mask>
      <path
        fill="#fff"
        d="M77.756 85.354H7.644a7.552 7.552 0 010-15.103h70.112a7.552 7.552 0 010 15.103z"
      ></path>

      <mask
        id="mask4_2081_39"
        style={{ maskType: "luminance" }}
        width="86"
        height="16"
        x="0"
        y="0"
        maskUnits="userSpaceOnUse"
      >
        <path fill="#fff" d="M.04.54h85.407v15.175H.039V.541z"></path>
      </mask>
      <path
        fill="#fff"
        d="M85.307 8.09a7.55 7.55 0 01-7.55 7.553H7.643a7.552 7.552 0 010-15.103h70.112c4.17 0 7.55 3.383 7.55 7.55z"
      ></path>

      <mask
        id="mask5_2081_39"
        style={{ maskType: "luminance" }}
        width="86"
        height="16"
        x="0"
        y="35"
        maskUnits="userSpaceOnUse"
      >
        <path fill="#fff" d="M.04 35.287h85.407v15.24H.039v-15.24z"></path>
      </mask>
      <path
        fill="#fff"
        d="M77.756 50.5H7.644a7.553 7.553 0 010-15.106h70.112c4.17 0 7.55 3.383 7.55 7.553s-3.38 7.553-7.55 7.553z"
      ></path>
    </svg>
  );
}

export default Icon;
